import { Container } from "./styles";
import habb from "../../assets/habb.jpg";
import habblogo from "../../assets/habblogo.png";
import senth from "../../assets/senth.png";
import senthg from "../../assets/senthgreen.png";
import externalLink from "../../assets/external-link.svg";
import ScrollAnimation from "react-animate-on-scroll";
import github from "../../assets/github.svg";

export function Project() {
  return (
    <Container id="project">
      <h2>My Projects</h2>
      <div className="projects">

        {/* --- Senthvyra.com Portfolio Project --- */}
        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://github.com/senthinc" target="_blank" rel="noreferrer">
                  <img src={senth} alt="GitHub Repository" />
                </a>
                <a href="https://senthvyra.com" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Live Project" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Senthvyra Personal Portfolio</h3>
              <p>
                A digital identity crafted to showcase my projects, resume, and philosophy. Built with React, styled for elegance, and hosted with modern DevOps.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React.js</li>
                <li>Styled Components</li>
                <li>Netlify</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        {/* --- HABB Inc Client Project --- */}
        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://github.com/habbinc" target="_blank" rel="noreferrer">
                  <img src={github} alt="GitHub Repository" />
                </a>
                <a href="https://habb.lk" target="_blank" rel="noreferrer">
                  <img src={habb} alt="Live Project" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>HABB Inc Official Platform</h3>
              <p>
                HABB’s digital gateway to custom software, cloud services, and AI innovation. Designed for scalability, built with the MERN stack.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React.js</li>
                <li>Node.js</li>
                <li>MongoDB</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        {/* --- Senth Inc Business Directory --- */}
        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://linkedin.com/company/senth" target="_blank" rel="noreferrer">
                  <img src={senthg} alt="LinkedIn Page" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Senth Inc Directory & Branding</h3>
              <p>
                A creative branding and business directory site for tech products and services by Senth Inc. Sleek and responsive with business-centric UI/UX.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Next.js</li>
                <li>Tailwind CSS</li>
                <li>Firebase</li>
              </ul>
  

            </footer>
          </div>
        </ScrollAnimation>

      </div>
    </Container>
  );
}
